export default "__VITE_ASSET__BeV1mSfK__"